(function () {
  const pairedProduct = document.querySelectorAll(".paired-product-wrapper"),
    isOnlyOne = pairedProduct[0].dataset.one == "true" ? true : false,
    formId = pairedProduct[0].dataset.form,
    selects = document.querySelectorAll(".paired-product-wrapper select"),
    checkboxes = document.querySelectorAll(".paired-product-wrapper input[type='checkbox']"),
    button = document.querySelector("#add-selected-items")
  ;  

// EVENT LISTENERS
  selects.forEach((select) => select.addEventListener("change", handleSelect));
  checkboxes.forEach((checkbox) => checkbox.addEventListener("change", handleCheckbox));
  button.addEventListener("click", handleSubmitSelectedProducts);

// HANDLES
  function handleSelect(event) {
    let checkbox, isOtherChecked = false;
  
    checkboxes.forEach((_checkbox) => { 
      if (_checkbox.dataset.product == event.target.dataset.product) {
        checkbox = _checkbox;
      } else if (_checkbox.checked && isOnlyOne){
        isOtherChecked = true
      }
    }); 
    
    if (event.target.selectedOptions[0].value == "") checkbox.checked = false;
    if (event.target.selectedOptions[0].value == "" || (isOnlyOne && isOtherChecked)) {
      checkbox.disabled = true;
    } else if (!isOtherChecked) {
      checkbox.disabled = false;
    }
    toggleAddButton();
  }

  function handleCheckbox(event) {
    if(isOnlyOne && checkboxes.length > 1) toggleOtherCheckboxes(event.target.dataset.product, event.target.checked);
    toggleAddButton();
  }

  function handleSubmitSelectedProducts(event) {
    const 
      form = document.querySelector(`#${formId}`),
      input = form.querySelector('input[name="id"]'),
      button = form.querySelector('button#product-form__submit'),
      defaultValue = form.querySelector('input[name="id"]').value
    ;

    pairedProduct.forEach((product, i) => {
      const 
        checkbox = product.querySelector('input[type="checkbox"]'),
        select = product.querySelector('select'),
        variantId = select[select.selectedIndex].dataset.id
      ;

      if (checkbox.checked) {
        input.value = variantId;
        if (i > 0) {
          setTimeout(function () { button.click(); }, 1000);
        } else {
          button.click();
        }
      }
    });

    setTimeout(function () { input.value = defaultValue; }, 1000);
  }

// TOGGLES
  function toggleAddButton() {
    let isChecked = false;
    checkboxes.forEach((checkbox) => {
      if (checkbox.checked) isChecked = true;
    })
    button.disabled = !isChecked;
  }

  function toggleOtherCheckboxes(productId, isChecked) {
    checkboxes.forEach((checkbox) => {
      if(checkbox.dataset.product != productId) {
        if(isChecked) {
          checkbox.disabled = isChecked;
        } else {
          const select = document.querySelector(`.paired-product-wrapper select[data-product='${checkbox.dataset.product}']`);
          checkbox.disabled = select.selectedOptions[0].value == "" ? true : false;
        }
      }
    });
  }
})();